function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo30YearsWhite(_ref, svgRef) {
  var _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13;
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 54,
    viewBox: "0 0 270 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M26.9292 40.3794C34.3654 40.3794 40.3937 34.3532 40.3937 26.9195C40.3937 19.4859 34.3654 13.4597 26.9292 13.4597C19.4929 13.4597 13.4646 19.4859 13.4646 26.9195C13.4646 34.3532 19.4929 40.3794 26.9292 40.3794Z",
    fill: "url(#paint0_linear_5186_946)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9292 40.3794C34.3654 40.3794 40.3937 34.3532 40.3937 26.9195C40.3937 19.4859 34.3654 13.4597 26.9292 13.4597C19.4929 13.4597 13.4646 19.4859 13.4646 26.9195C13.4646 34.3532 19.4929 40.3794 26.9292 40.3794Z",
    fill: "url(#paint1_linear_5186_946)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5726 15.7581C15.0962 19.8286 15.582 27.1626 20.6591 32.1373C25.7344 37.112 33.4773 37.8466 37.9555 33.7743C38.4629 33.313 38.9065 32.8098 39.287 32.2729C39.9992 30.6322 40.394 28.822 40.394 26.9195C40.394 19.4859 34.3657 13.4597 26.9295 13.4597C24.4266 13.4597 22.0832 14.1424 20.0755 15.3316C19.9037 15.4674 19.736 15.6095 19.5726 15.7581Z",
    fill: "url(#paint2_radial_5186_946)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4867 15.7573C18.3679 18.983 20.8354 23.9958 25.9986 26.9508C31.1618 29.9076 37.0631 29.6881 39.1836 26.4607C39.7824 25.5492 40.0153 24.4954 39.925 23.3858C38.3724 17.6663 33.1423 13.4597 26.9293 13.4597C25.053 13.4597 23.2663 13.8434 21.6435 14.5365C21.1865 14.8789 20.7962 15.286 20.4867 15.7573Z",
    fill: "url(#paint3_linear_5186_946)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6778 32.7763C82.4739 33.5769 83.4146 34.2066 84.4998 34.6681C85.5849 35.1296 86.7918 35.3718 88.0924 35.3769C89.0559 35.3769 89.9966 35.2316 90.889 34.9154C91.7815 34.6222 92.6004 34.2117 93.3484 33.6533C94.0735 33.1205 94.6998 32.4652 95.2297 31.7131C95.7596 30.9635 96.145 30.1374 96.3858 29.217H92.6005C92.4331 29.653 92.1922 30.0405 91.8778 30.3796C91.5634 30.7187 91.2034 31.0094 90.7927 31.2287C90.3819 31.4709 89.9738 31.6647 89.5149 31.787C89.0559 31.9069 88.5742 31.9808 88.0924 31.9808C87.2735 31.9808 86.5255 31.8355 85.8739 31.5448C85.197 31.2797 84.6189 30.8921 84.1371 30.3822C83.6554 29.8723 83.2954 29.2909 83.0292 28.6357C82.7655 27.983 82.6438 27.2538 82.6438 26.4787C82.6438 25.7036 82.763 24.977 83.0292 24.3217C83.2929 23.6665 83.6554 23.0851 84.1371 22.5752C84.6214 22.0653 85.1995 21.6778 85.8739 21.3871C86.5255 21.1194 87.2735 20.974 88.0924 20.974C88.5742 20.974 89.0559 21.0454 89.5149 21.1678C89.9738 21.2877 90.3819 21.4814 90.7927 21.7007C91.2034 21.9429 91.5634 22.2336 91.8778 22.5727C92.1897 22.9118 92.4306 23.2993 92.6005 23.7353H96.3858C96.145 22.8149 95.7596 21.9659 95.2297 21.2138C94.6998 20.4616 94.071 19.8318 93.3484 19.2735C92.6004 18.738 91.7815 18.3276 90.889 18.0114C89.9966 17.7208 89.0559 17.5754 88.0924 17.5754C86.7892 17.5754 85.5849 17.7921 84.4998 18.2536C83.4146 18.7151 82.4739 19.3448 81.6778 20.1454C80.8817 20.946 80.2554 21.8919 79.7965 22.9832C79.3401 24.0744 79.1221 25.237 79.1221 26.4736C79.1221 27.7102 79.3376 28.8728 79.7965 29.964C80.2554 31.0553 80.8817 31.9757 81.6778 32.7763Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.5165 25.7969C59.0102 25.3344 58.3851 24.9716 57.6865 24.7034C56.9652 24.4377 56.1958 24.315 55.3529 24.3125H50.4605V21.2031H59.7088V17.851H46.9474V35.1019H55.3529C56.1932 35.1019 56.9652 34.9563 57.6865 34.688C58.3851 34.4223 59.0102 34.0569 59.5165 33.5715C60.0227 33.1091 60.4302 32.5266 60.744 31.87C61.0326 31.2159 61.1768 30.5107 61.1768 29.7085C61.1768 28.9062 61.0326 28.1781 60.744 27.5215C60.4302 26.8648 60.0227 26.2823 59.5165 25.7969ZM55.3048 27.547C56.0515 27.547 56.6514 27.7412 57.1095 28.1065C57.5676 28.4693 57.7827 29.0033 57.7827 29.7085C57.7827 30.4137 57.5676 30.9221 57.1095 31.2874C56.6514 31.6528 56.0515 31.8469 55.3048 31.8469H50.4605V27.547H55.3048Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.2 17.8582V24.8794H112.224L116.239 19.8266V24.8794H117.413V17.8582H116.389L112.385 22.9024V17.8582H111.2Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.317 21.1809L102.827 17.8588H101.753V24.88H102.927V19.8358L105.327 23.0305L107.706 19.846V24.88H108.891V17.8588H107.816L105.317 21.1809Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.987 22.4473H120.892V24.8794H119.718V17.8582H121.987C123.452 17.8582 124.455 18.8568 124.455 20.1527C124.455 21.4486 123.452 22.4473 121.987 22.4473ZM121.976 18.9468H120.892V21.3603H121.976C122.819 21.3603 123.302 20.8355 123.302 20.1544C123.302 19.47 122.819 18.9468 121.976 18.9468Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.753 27.7394V34.7606H102.777L106.792 29.7078V34.7606H107.966V27.7394H106.942L102.938 32.7837V27.7394H101.753Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.271 27.7394H111.445V30.6471H114.969V27.7394H116.143V34.7606H114.969V31.7442H111.445V34.7606H110.271V27.7394Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.914 27.7394H118.455V34.7606H121.226C122.581 34.7606 123.524 33.8605 123.524 32.7038C123.524 31.8343 123.031 31.2993 122.379 31.0326C122.771 30.7456 123.041 30.3108 123.041 29.6773C123.041 28.6192 122.19 27.7394 120.914 27.7394ZM121.888 29.7469C121.888 30.2904 121.497 30.6963 120.853 30.6963H119.629V28.7975H120.853C121.497 28.7975 121.888 29.2323 121.888 29.7469ZM122.379 32.6936C122.379 33.2864 121.959 33.7025 121.195 33.7025H119.629V31.6848H121.195C121.957 31.6848 122.379 32.1094 122.379 32.6936Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.388 27.7394H129.674V28.8467H126.562V30.6471H129.072V31.7544H126.562V33.6532H129.674V34.7606H125.388V27.7394Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.71 27.6207C132.583 27.6207 130.997 29.1934 130.997 31.2502C130.997 33.307 132.583 34.8797 134.71 34.8797C136.426 34.8797 137.791 33.7809 138.143 32.4068H136.877C136.576 33.2085 135.712 33.7622 134.709 33.7622C133.224 33.7622 132.18 32.665 132.18 31.2502C132.18 29.8354 133.223 28.7383 134.709 28.7383C135.714 28.7383 136.576 29.292 136.877 30.0936H138.143C137.793 28.7179 136.427 27.6207 134.71 27.6207Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.333 28.8467H139.265V27.7394H144.585V28.8467H142.507V34.7606H141.333V28.8467Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.254 27.7394V34.7606H147.278L151.293 29.7078V34.7606H152.467V27.7394H151.443L147.438 32.7837V27.7394H146.254Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.236 33.6532V36.2246H160.152V34.7606H154.771V27.7394H155.956V33.6532H159.148V27.7394H160.333V33.6532H161.236Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.016 27.7394V34.7606H164.04L168.055 29.7078V34.7606H169.229V27.7394H168.205L164.2 32.7837V27.7394H163.016Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.535 34.7606V27.7393H172.719V32.7836L176.724 27.7393H177.748V34.7606H176.574V29.7078L172.559 34.7606H171.535Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.071 25.652H173.843C173.843 26.2447 174.184 26.6116 174.736 26.6116C175.288 26.6116 175.629 26.2464 175.629 25.652H176.401C176.401 26.6608 175.658 27.2944 174.734 27.2944C173.814 27.2944 173.071 26.6608 173.071 25.652Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7341 35.1019H64.3687V17.851H67.7341V25.1633L73.7198 17.851H77.9037L71.0766 26.1366L79.3278 35.1019H74.9336L67.7341 27.2788V35.1019Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.606 40.3794L184.606 13.4597L185.669 13.4597L185.669 40.3794L184.606 40.3794Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.22 26.5654C215.22 30.1647 212.301 33.0826 208.701 33.0826C205.1 33.0826 202.181 30.1647 202.181 26.5654C202.181 22.966 205.1 20.0481 208.701 20.0481C212.301 20.0481 215.22 22.966 215.22 26.5654ZM217.559 26.5654C217.559 31.4559 213.593 35.4205 208.701 35.4205C203.809 35.4205 199.843 31.4559 199.843 26.5654C199.843 21.6748 203.809 17.7102 208.701 17.7102C213.593 17.7102 217.559 21.6748 217.559 26.5654Z",
    fill: "url(#paint4_linear_5186_946)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.425 33.2509C200.299 33.2509 201.705 32.1661 201.705 30.3031C201.705 28.11 200.076 27.3554 197.667 27.3554H196.886V25.0207H197.555C200.054 25.0207 201.303 24.1482 201.303 22.3795C201.303 20.658 199.987 19.8562 198.492 19.8562C196.529 19.8562 195.436 21.1061 195.19 23.1105H192.602C192.848 19.8562 195.079 17.7102 198.648 17.7102C201.348 17.7102 204.025 19.0072 204.025 22.2144C204.025 23.9123 203.088 25.3273 201.66 26.0583C203.623 26.813 204.449 28.4637 204.449 30.2324C204.449 33.7226 201.616 35.4205 198.381 35.4205C194.633 35.4205 192.58 32.8264 192.402 29.8079H194.99C195.235 31.6945 196.35 33.2509 198.425 33.2509Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.061 18.9728V24.8866H238.219V18.9728H240.266V17.8652H235.023V18.9728H237.061Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.096 31.2505C228.096 33.2778 229.709 34.8798 231.727 34.8798C233.735 34.8798 235.358 33.2778 235.358 31.2505C235.358 29.2232 233.735 27.6211 231.727 27.6211C229.709 27.6211 228.096 29.2232 228.096 31.2505ZM234.18 31.2505C234.18 32.635 233.112 33.7623 231.727 33.7623C230.332 33.7623 229.264 32.635 229.264 31.2505C229.264 29.866 230.332 28.7386 231.727 28.7386C233.112 28.7386 234.18 29.866 234.18 31.2505Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.139 30.5186H239.652C241.017 30.5186 242.036 31.3296 242.036 32.6448C242.036 33.9403 241.017 34.7611 239.652 34.7611H236.971V27.7398H241.403V28.8474H238.139V30.5186ZM240.889 32.6448C240.889 31.9625 240.434 31.5867 239.642 31.5867H238.139V33.6832H239.642C240.434 33.6832 240.889 33.3173 240.889 32.6448Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.901 27.7398V34.7611H248.125V33.6535H245.058V31.7548H247.531V30.6472H245.058V28.8474H248.125V27.7398H243.901Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.477 34.7611V36.2247H256.535V33.6535H255.645V27.7398H250.629V31.4284C250.629 33.2085 250.204 33.6535 249.729 33.6535H249.601V36.2247H250.659V34.7611H255.477ZM251.797 31.5669V28.8474H254.488V33.6535H251.381C251.648 33.2184 251.797 32.6349 251.797 31.5669Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.327 34.7609V28.8472H221.954V34.7609H220.806V27.7396H226.475V34.7609H225.327Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.442 24.8866V17.8652H233.666V18.9728H230.6V20.7727H233.073V21.8803H230.6V23.779H233.666V24.8866H229.442Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.994 17.8652V22.6615C221.994 23.6702 221.736 23.9174 221.261 23.9174C221.083 23.9174 220.935 23.9076 220.806 23.8878V24.9657C220.955 24.9954 221.163 25.0053 221.41 25.0053C222.458 25.0053 223.161 24.3328 223.161 22.8197V18.9728H225.852V24.8866H227.019V17.8652H221.994Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5186_946",
    x1: 26.5926,
    y1: 40.0429,
    x2: 26.7899,
    y2: 14.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E66E6",
    style: (_ref2 = {
      stopColor: "#1E66E6"
    }, _defineProperty(_ref2, "stopColor", "color(display-p3 0.1163 0.4017 0.9000)"), _defineProperty(_ref2, "stopOpacity", 1), _ref2)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#8CB4F2",
    style: (_ref3 = {
      stopColor: "#8CB4F2"
    }, _defineProperty(_ref3, "stopColor", "color(display-p3 0.5490 0.7059 0.9490)"), _defineProperty(_ref3, "stopOpacity", 1), _ref3)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F7FE",
    style: (_ref4 = {
      stopColor: "#F1F7FE"
    }, _defineProperty(_ref4, "stopColor", "color(display-p3 0.9451 0.9686 0.9961)"), _defineProperty(_ref4, "stopOpacity", 1), _ref4)
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5186_946",
    x1: 38.374,
    y1: 32.9765,
    x2: 24.2399,
    y2: 22.2038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D87EA",
    style: (_ref5 = {
      stopColor: "#4D87EA"
    }, _defineProperty(_ref5, "stopColor", "color(display-p3 0.3020 0.5294 0.9176)"), _defineProperty(_ref5, "stopOpacity", 1), _ref5)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7EAAF0",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_5186_946",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.8773 30.0859) rotate(-152.961) scale(32.055 66.079)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.103242,
    stopColor: "#4382EF",
    style: (_ref6 = {
      stopColor: "#4382EF"
    }, _defineProperty(_ref6, "stopColor", "color(display-p3 0.2617 0.5098 0.9375)"), _defineProperty(_ref6, "stopOpacity", 1), _ref6)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.459935,
    stopColor: "#7EAAF0",
    style: (_ref7 = {
      stopColor: "#7EAAF0"
    }, _defineProperty(_ref7, "stopColor", "color(display-p3 0.4941 0.6667 0.9412)"), _defineProperty(_ref7, "stopOpacity", 1), _ref7)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630708,
    stopColor: "#B2CDF6",
    style: (_ref8 = {
      stopColor: "#B2CDF6"
    }, _defineProperty(_ref8, "stopColor", "color(display-p3 0.6980 0.8039 0.9647)"), _defineProperty(_ref8, "stopOpacity", 1), _ref8)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794216,
    stopColor: "#F0F6FD",
    style: (_ref9 = {
      stopColor: "#F0F6FD"
    }, _defineProperty(_ref9, "stopColor", "color(display-p3 0.9412 0.9647 0.9922)"), _defineProperty(_ref9, "stopOpacity", 1), _ref9)
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5186_946",
    x1: 38.6849,
    y1: 18.1639,
    x2: 19.524,
    y2: 20.8645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CBFF4",
    style: (_ref10 = {
      stopColor: "#9CBFF4"
    }, _defineProperty(_ref10, "stopColor", "color(display-p3 0.6118 0.7490 0.9569)"), _defineProperty(_ref10, "stopOpacity", 1), _ref10)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476252,
    stopColor: "#CCE0FD",
    style: (_ref11 = {
      stopColor: "#CCE0FD"
    }, _defineProperty(_ref11, "stopColor", "color(display-p3 0.8000 0.8784 0.9922)"), _defineProperty(_ref11, "stopOpacity", 1), _ref11)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.770833,
    stopColor: "#E9F2FE",
    style: (_ref12 = {
      stopColor: "#E9F2FE"
    }, _defineProperty(_ref12, "stopColor", "color(display-p3 0.9137 0.9490 0.9961)"), _defineProperty(_ref12, "stopOpacity", 1), _ref12)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F7FE",
    style: (_ref13 = {
      stopColor: "#F1F7FE"
    }, _defineProperty(_ref13, "stopColor", "color(display-p3 0.9451 0.9686 0.9961)"), _defineProperty(_ref13, "stopOpacity", 1), _ref13)
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5186_946",
    x1: 208.705,
    y1: 30.2485,
    x2: 200.94,
    y2: 30.2485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo30YearsWhite);
export default __webpack_public_path__ + "static/media/logo_30_years_white.7f7bf26ea875c50c1526a0418810769d.svg";
export { ForwardRef as ReactComponent };